import * as badges from '@wix/auto_sdk_members_badges';
import * as badgesV2 from '@wix/auto_sdk_members_badges-v-2';
import * as badgeAssignments from '@wix/auto_sdk_members_badge-assignments';
import * as authentication from '@wix/auto_sdk_members_authentication';
import * as membersAbout from '@wix/auto_sdk_members_members-about';
import * as userMember from '@wix/auto_sdk_members_user-member';
import * as customFields from '@wix/auto_sdk_members_custom-fields';
import * as customFieldApplications from '@wix/auto_sdk_members_custom-field-applications';
import * as customFieldSuggestions from '@wix/auto_sdk_members_custom-field-suggestions';
import * as defaultPrivacy from '@wix/auto_sdk_members_default-privacy';
import * as members from '@wix/auto_sdk_members_members';
import * as memberPrivacySettings from '@wix/auto_sdk_members_member-privacy-settings';
import * as memberReport from '@wix/auto_sdk_members_member-report';
import * as memberRoleDefinition from '@wix/auto_sdk_members_member-role-definition';
import * as memberToMemberBlock from '@wix/auto_sdk_members_member-to-member-block';
import * as authorization from '@wix/auto_sdk_members_authorization';
import * as memberFollowers from '@wix/auto_sdk_members_member-followers';

export {
  badges,
  badgesV2,
  badgeAssignments,
  authentication,
  membersAbout,
  userMember,
  customFields,
  customFieldApplications,
  customFieldSuggestions,
  defaultPrivacy,
  members,
  memberPrivacySettings,
  memberReport,
  memberRoleDefinition,
  memberToMemberBlock,
  authorization,
  memberFollowers,
};
